import $ from 'jquery'

class LayoutFullWidth extends window.HTMLDivElement {
  constructor () {
    super()
    this.$ = $(this)
    this.resolveElements()
  }

  resolveElements () {
  }

  connectedCallback () {
  }
}

window.customElements.define('flynt-layout-full-width', LayoutFullWidth, {extends: 'div'})



// WEBPACK FOOTER //
// ./Components/LayoutFullWidth/script.js